import { render, staticRenderFns } from "./DeliveryOrderDetail.vue?vue&type=template&id=5286704c&scoped=true"
import script from "./DeliveryOrderDetail.vue?vue&type=script&lang=js"
export * from "./DeliveryOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./DeliveryOrderDetail.vue?vue&type=style&index=0&id=5286704c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5286704c",
  null
  
)

export default component.exports